import type { SubscriptionCurrency } from '../types/api'

/**
 * Форматирование цены курса. Валюта приходит с бэкенда; в EU-сервисе — EUR.
 * Локаль en — интерфейс на английском. Дробная часть скрывается для целых сумм.
 */
export const formatPrice = (
  price: number,
  currency: SubscriptionCurrency = 'EUR',
): string =>
  new Intl.NumberFormat('en-IE', {
    style: 'currency',
    currency,
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  }).format(price)
